import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from 'hook/use-media-query';
import { playerSharedPropTypes } from 'utils/prop-types';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Icons, { Backward30Icon, Forward30Icon, PauseIcon } from 'components/icons';
import clsx from 'clsx';
import useStyles from './navigation.styles';

const Navigation = memo((props) => {
  const classes = useStyles();
  const isTablet = useMediaQuery('tablet');
  const {
    isPlaying,
    className,
    playerRef,
    iconClassName,
    iconBtnClassName,
    playTrackAction,
    pauseTrackAction,
    backwardIconClassName,
    pauseIconClassName,
    playIconClassName,
    forwardIconClassName,
  } = props;

  const handlePlayClick = useCallback(() => {
    playTrackAction();
  }, []);

  const handlePauseClick = useCallback(() => {
    pauseTrackAction();
  }, []);

  const handleBackwardClick = useCallback(() => {
    const playedSeconds = playerRef.current.currentTime;
    const playedMinus30 = playedSeconds - 30;
    const newTime = playedMinus30 < 0 ? 0 : playedMinus30;

    playerRef.current.currentTime = newTime;
  }, []);

  const handleForwardClick = useCallback(() => {
    const { duration } = playerRef.current;
    const playedSeconds = playerRef.current.currentTime;
    const playedPlus30 = playedSeconds + 30;
    const newTime = playedPlus30 > duration ? duration : playedPlus30;

    playerRef.current.currentTime = newTime;
  }, []);

  return (
    <Box className={clsx(classes.trackNavigation, className)}>
      {isTablet && (
        <IconButton onClick={handleBackwardClick} className={clsx(classes.iconBtn, iconBtnClassName)}>
          <Backward30Icon className={clsx(classes.icon, iconClassName, backwardIconClassName)} />
        </IconButton>
      )}
      {isPlaying ? (
        <IconButton className={clsx(classes.iconBtn, iconBtnClassName)} onClick={handlePauseClick}>
          <PauseIcon className={clsx(classes.icon, iconClassName, pauseIconClassName)} />
        </IconButton>
      ) : (
        <IconButton className={clsx(classes.iconBtn, iconBtnClassName)} onClick={handlePlayClick}>
          <Icons.Play className={clsx(classes.icon, iconClassName, playIconClassName)} />
        </IconButton>
      )}
      {!isTablet && (
        <IconButton onClick={handleBackwardClick} className={clsx(classes.iconBtn, iconBtnClassName)}>
          <Backward30Icon className={clsx(classes.icon, iconClassName, backwardIconClassName)} />
        </IconButton>
      )}
      <IconButton onClick={handleForwardClick} className={clsx(classes.iconBtn, iconBtnClassName)}>
        <Forward30Icon className={clsx(classes.icon, iconClassName, forwardIconClassName)} />
      </IconButton>
    </Box>
  );
});

Navigation.propTypes = {
  playerRef: playerSharedPropTypes.playerRef,
  isPlaying: PropTypes.bool.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  playTrackAction: PropTypes.func.isRequired,
  pauseTrackAction: PropTypes.func.isRequired,
  iconBtnClassName: PropTypes.string,
  backwardIconClassName: PropTypes.string,
  pauseIconClassName: PropTypes.string,
  playIconClassName: PropTypes.string,
  forwardIconClassName: PropTypes.string,
};

Navigation.defaultProps = {
  className: '',
  iconClassName: '',
  iconBtnClassName: '',
  backwardIconClassName: '',
  pauseIconClassName: '',
  playIconClassName: '',
  forwardIconClassName: '',
};

export default Navigation;
